import { createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk"; // Remove curly braces, as it's a default export
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import loader from "./store/reducers/loaderReducer";
import snackbar from "./store/reducers/snackbarReducer";
import login from "./features/auth/authReducer";
import client from "./features/admin/adminReducer";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  loader,
  snackbar,
  login,
  client,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

const storeConfig = { store, persistor };
export default storeConfig; 
